import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useNavigate } from 'react-router-dom';
import styles from './AccountSuccess.module.scss';
const AccountSuccess = () => {
    const navigate = useNavigate();
    return (_jsx("div", { className: styles.createAccountWrapper, children: _jsxs("div", { className: styles.headingContainer, children: [_jsx("h3", { children: "Thanks!" }), _jsx("p", { children: "We\u2019ve sent a verification link to your email. Simply click that to finish setting up your account." })] }) }));
};
export default AccountSuccess;
